//需要隐藏调左侧菜单的路由
export const hideRoutes: string[] = [
  "/dashboard",
  "/version",
  "/userinfo",
  "/VideoIntroducePage",
  "/train/VideoIntroducePage",
  "/process-center",
  "/message-center",
  "/appStore/list",
  "/maintenanceAcceptance",
  "/userinfo",
  "/platform-electronic-visa/workbench",
  "/platform-electronic-visa/workbench/contract-comparison",
  "/platform-electronic-visa/workbench/contract-review",
];

//屏蔽倒推路由菜单逻辑的路由
export const displayAllMenuRoutes: string[] = ["/version", "/userinfo", "/appStore/list"];
// 二级菜单需要展示顶部按钮的路由
import sideIconAdd from "@/assets/images/dzq/side_icon_add.png";
import sideIconShop from "@/assets/images/dzq/side_icon_shop.png";
import store from "@/store";
export const showLayoutSideBtn = [
  {
    include: "/platform-electronic-visa/signature",
    path: "/platform-electronic-visa/signature/add",
    btnText: "发起签署",
    icon: sideIconAdd,
  },
  {
    include: "/expense",
    path: "/expense/goorder",
    btnText: "去订购",
    icon: sideIconShop,
  },
];
